import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from 'fines-portal/core/data-access/config';
import { EnvironmentLoader } from 'fines-portal/core/data-access/environment';
import { finesPortalRoutes } from 'fines-portal/core/feature/router';
import { RootComponent } from 'fines-portal/core/ui/router';
import { environment as defaultEnvironment } from './environments/environment';

export async function start() {
    const environment = await EnvironmentLoader.load(
        defaultEnvironment.assetConfigPath,
        defaultEnvironment,
        'environment',
    );

    await bootstrapApplication(
        RootComponent,
        createAppConfig(environment, finesPortalRoutes),
    )
        .then(() => {
            console.log('Application started');
        })
        .catch((err: unknown) => {
            console.error(err);
        });
}

declare const window: { test: boolean };
if (!window.test) {
    /* istanbul ignore next */
    start().catch((err: unknown) => {
        console.error(err);
    });
}
